import { v4 as uuid } from 'uuid';

export const backgroundContentTemplate = () => ({
  config: {
    content: {
      type: 'image',
      id: uuid(),
      imageUrl:
        'https://images.appcues.com/v1662654207/mobile-builder/spacer.gif',
      style: {
        backgroundImage: {
          imageUrl:
            'https://images.appcues.com/v1657809085/mobile-builder/default-image.jpg',
          intrinsicSize: {
            width: 1920,
            height: 1080,
          },
          contentMode: 'fill',
          verticalAlignment: 'center',
          horizontalAlignment: 'center',
        },
      },
    },
  },
});
